module.exports = __webpack_public_path__ + "static/media/navodaya_bank_details.3481b404.png";